import dbConnect from '../../utils/dbConnect'
import Event from '../../models/Event'
import Parcour from '../../models/Parcour'
import PointOfInterest from '../../models/PointOfInterest'
import AtmosphericArea from '../../models/AtmosphericArea'
import Map from '../../components/Map'

const EventPage = ({ event, parcours, pois, atmosphericareas }) => {
  return <Map event={event} parcours={parcours} pois={pois} atmosphericareas={atmosphericareas} />
}

export const getStaticPaths = async () => {
  await dbConnect()
  const events = await Event.find({})

  // Get the paths we want to pre-render based on events
  const paths = events.map((event) => ({
    params: { id: event.id },
  }))

  // We'll pre-render only these paths at build time.
  // { fallback: false } means other routes should 404.
  return { paths, fallback: false }
}

export const getStaticProps = async ({ params }) => {
  const serializeDoc = (doc) => {
    const item = doc.toObject()
    item._id = item._id.toString()
    if (item.eventId) {
      item.eventId = item.eventId.toString()
    }
    return item
  }
  const parseResult = (result) => result.map((doc) => serializeDoc(doc))
  await dbConnect()

  const doc = await Event.findById({ _id: params.id })
  const event = serializeDoc(doc)

  const resultParcours = await Parcour.find({ eventId: params.id })
  const parcours = parseResult(resultParcours)

  const resultPoI = await PointOfInterest.find({ eventId: params.id })
  const pois = parseResult(resultPoI)

  const resultAtmosphericArea = await AtmosphericArea.find({ eventId: params.id })
  const atmosphericareas = parseResult(resultAtmosphericArea)

  return {
    props: {
      event: event,
      parcours: parcours,
      atmosphericareas: atmosphericareas,
      pois: pois,
    },
  }
}

export default EventPage
